import { styled } from "@mui/material";

import { TEST_IDS } from "constants/TestIds";

import { RegionItem, RegionItemProps } from "./RegionItem";
import {
  RegionTreeSelectContextProvider,
  RegionTreeSelectContextProviderProps,
} from "./RegionTreeSelectContext";

export interface RegionTreeSelectProps
  extends Omit<RegionTreeSelectContextProviderProps, "children"> {
  regions: RegionItemProps["region"][];
}

export function RegionTreeSelect({
  regions,
  ...contextProviderProps
}: RegionTreeSelectProps) {
  return (
    <RegionTreeSelectContextProvider {...contextProviderProps}>
      <Wrapper data-testid={TEST_IDS.regionTreeSelect}>
        {regions.map((region) => (
          <RegionItem key={region.regionCode} region={region} />
        ))}
      </Wrapper>
    </RegionTreeSelectContextProvider>
  );
}

const Wrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(1),
  cursor: "initial",
}));
